export interface UserAccountDetailsResponse {
  ssoId: string;
  customerNumber: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  salutation?: UserSalutation;
  phoneNumber?: string;
  phoneNumberCountryCode?: string;
}

export enum UserSalutation {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
